import { c as _c } from "react/compiler-runtime";
import { Gender } from "@/components/modules/listings/api/schema";
import { cn } from "@/lib/utils";
import { Mars, Venus } from "lucide-react";
type GenderIconProps = {
  gender?: Gender;
  className?: string;
};
export function GenderIcon(t0) {
  const $ = _c(8);
  const {
    gender,
    className
  } = t0;
  if (gender === Gender.MALE) {
    let t1;
    if ($[0] !== className) {
      t1 = cn("w-5 h-5 text-blue-500 shrink-0", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <Mars className={t1} />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (gender === Gender.FEMALE) {
    let t1;
    if ($[4] !== className) {
      t1 = cn("w-5 h-5 text-pink-500 shrink-0", className);
      $[4] = className;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== t1) {
      t2 = <Venus className={t1} />;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  return null;
}